import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";
import { Compare } from "../common/slider";
import { useState } from "react";

function Offer3Nawodnienie() {
  const [activeTransform, setActiveTransform] = useState(1);

  const handleChooseTransform = (index: number) => {
    setActiveTransform(index);
  };
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/03/oferta-nawodnienie-new.jpeg"
          alt="Instalacja nawadniająca w ogrodzie - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Automatyczne systemy nawadniania ogrodów Gdańsk, Gdynia, Kaszuby
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Projektowanie i montaż oszczędnych instalacji nawadniających
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Piękny i soczysty trawnik wokół nowego domu w Gdańsku, Gdyni, Wejherowie czy Kartuzach wymaga regularnego i optymalnego podlewania. Projektujemy i montujemy nowoczesne systemy nawadniania z czujnikami deszczu i sterowaniem Wi-Fi, które oszczędzają wodę i Twój czas. Nasze instalacje idealnie współgrają z usługą <a href="/zakladanie-ogrodu/trawa-z-rolki" className="underline hover:opacity-80">montażu trawnika z rolki</a> oraz kompleksowego zakładania ogrodów.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Kiedy najlepiej podlewać ogród
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Co zyskasz zakładając system nawadniający w ogrodzie
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Korzyści z instalacji systemu nawadniającego
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Nawadnianie ogrodu jakiej firmy sprawdza się najlepiej?
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Jak wykonać instalację nawadniającą?
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Kiedy najlepiej podlewać ogród</h2>
          <p>
            Widok soczystej zieleni cieszy oczy. Jeśli ma tak być zawsze, to
            rośliny trzeba regularnie podlewać. Najlepszą porą na podlewanie
            jest poranek. Wtedy rośliny najlepiej wykorzystają dostarczoną im
            wodę.
          </p>
          <p>
            W środku dnia w pełnym słońcu, ze względu na krople wody,
            delikatniejsze rośliny mogą zostać poparzone. Wtedy woda szybko
            paruje i po niedługim czasie po podlewaniu nie ma już śladu.
          </p>
          <p>
            Późny wieczór też nie jest dobrym czasem na podlewanie. Woda nie
            zdąży wyschnąć przed nocą, co naraża rośliny na choroby grzybowe.
            Nie każdy ma czas, żeby nawadniać ogród wczesnym rankiem, kiedy jest
            to najlepsze dla roślin. Dlatego warto zainwestować w automatyczny
            system nawadniający.
          </p>

          <h2 id="2">Co zyskasz zakładając system nawadniający w ogrodzie</h2>
          <p>
            Zlecając nam wykonanie systemu nawadniającego, już nigdy nie
            będziesz mieć problemów z plączącymi się wężami do podlewania. Cały
            system będzie schowany pod ziemią. Ciągłe zwijanie i rozwijanie węży
            ogrodowych może być męczące. System nawadniający uwolni Cię od tego.
            Dzięki nam zyskasz czas na to, co najważniejsze – relaks w ogrodzie,
            zabawę z dziećmi czy spotkania ze znajomymi.
          </p>

          <h2 id="3">Korzyści z instalacji systemu nawadniającego</h2>
          <p>
            Rośliny lepiej rosną, gdy są równomiernie podlewane. Nie zawsze
            sprawdzi się tu ręczne podlewanie. System nawadniający jest w stanie
            precyzyjnie dawkować wodę, dzięki czemu rozwój roślin jest lepszy.
            Zobacz, jakie jeszcze są korzyści z zastosowania instalacji
            nawadniającej:
          </p>
          <ul>
            <li>oszczędność Twojego czasu</li>
            <li>oszczędność zużycia wody</li>
            <li>prawidłowy rozwój roślin</li>
            <li>jest w pełni automatyczna</li>
            <li>jest trwała i łatwa w użytkowaniu</li>
            <li>poprawia estetykę ogrodu</li>
          </ul>

          <h2 id="4">
            Nawadnianie ogrodu jakiej firmy sprawdza się najlepiej?
          </h2>
          <p>
            Wykonujemy systemy nawadniające według życzenia klientów. Jesteśmy w
            stanie przygotować taki system z części różnych producentów. Jednak
            z naszego doświadczenia polecamy systemy produkcji renomowanych
            firm, takich jak:
          </p>
          <ul>
            <li>Gardena</li>
            <li>Hunter</li>
            <li>Rain Bird</li>
          </ul>
          <p>
            System nawadniający trawnik czy ogród tych producentów będzie
            bardziej niezawodny. Posłuży bezawaryjnie przez długi czas, a jeśli
            zdarzy się usterka, części zamienne będą dostępne od ręki. Dzięki
            temu ewentualna naprawa nie potrwa długo, a w Twoim ogrodzie nie
            zabraknie wody.
          </p>

          <h2 id="5">Jak wykonać instalację nawadniającą?</h2>
          <p>
            Nawadnianie najlepiej zaplanować przed założeniem ogrodu czy
            trawnika. Można zrobić to samemu. Ale czy chcesz męczyć się przy
            kopaniu i układaniu instalacji? Czy dasz radę zrobić to za pierwszym
            razem, unikając błędów i poprawek? Czy wiesz, gdzie powinny być
            zraszacze, a gdzie nawadnianie kropelkowe?
          </p>
          <p>
            O wiele lepiej zlecić to profesjonalistom. Przygotujemy dla Ciebie
            wycenę, doradzimy i pomożemy wybrać najlepsze rozwiązania.
            Podpowiemy, jakie rośliny posadzić i jak poprowadzić linie
            nawadniające, żeby Twój ogród dobrze wyglądał. Pomagamy też w
            nawadnianiu i zakładaniu trawników.
          </p>
          <p>
            Układanie instalacji najlepiej wykonywać przed założeniem ogrodu czy
            trawnika, ale podejmiemy się montażu systemów nawadniających nawet w
            wieloletnich ogrodach bez szkody dla roślin. Oferujemy pełny zakres
            usług:
          </p>
          <ul>
            <li>zaprojektowanie instalacji</li>
            <li>wytyczenie i przygotowanie wykopów</li>
            <li>ułożenie rur wodnych</li>
            <li>montaż zraszaczy</li>
            <li>układanie linii kroplujących</li>
            <li>montaż i zaprogramowanie sterowników</li>
          </ul>
          <p>
            Nie musisz już więcej męczyć się ręcznym podlewaniem trawnika czy
            ogrodu. Już dziś umów się na montaż instalacji nawadniającej i ciesz
            się widokiem pięknej zieleni w Twoim ogrodzie bez zbędnego wysiłku.
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="px-6 pb-6 lg:px-24 lg:pb-12 flex flex-col gap-6">
        <div className="w-full bg-gray-100 rounded-xl p-6 flex flex-col gap-6">
          <div className="flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between">
            <div className="flex flex-col items-start justify-start gap-2">
              <h2 className="uppercase color-yellow text-xl">Transformacje</h2>
              <h3 className="text-3xl lg:text-5xl color-green">
                Zobacz jak odmieniamy{" "}
                <span className="color-yellow">ogrody</span>
              </h3>
            </div>
            <a href="/kontakt">
              <button className="button-green">Bezpłatna wycena</button>
            </a>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div
              id="chooseTransform1"
              onClick={() => handleChooseTransform(1)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[350px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/nawadnianie-1-po.jpg"
                alt="Realizacja systemu nawadniania ogrodu - widok po"
              />
            </div>
            <div
              id="chooseTransform2"
              onClick={() => handleChooseTransform(2)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[350px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/nawadnianie-2-po.jpg"
                alt="Realizacja systemu nawadniania ogrodu 2 - widok po"
              />
            </div>
          </div>
          <div className="">
            <div
              className={`w-full ${activeTransform === 1 ? "block" : "hidden"}`}
              id="transform1"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/nawadnianie-1-przed.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/nawadnianie-1-po.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 2 ? "block" : "hidden"}`}
              id="transform2"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/nawadnianie-2-przed.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/nawadnianie-2-po.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
          </div>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/nawodnienie-1.jpeg"
              alt="Instalacja nawadniająca w ogrodzie - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/nawodnienie-2.jpeg"
              alt="Instalacja nawadniająca w ogrodzie - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/nawodnienie-3.jpeg"
              alt="Instalacja nawadniająca w ogrodzie - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/nawodnienie-4.jpeg"
              alt="Instalacja nawadniająca w ogrodzie - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/nawodnienie-5.jpeg"
              alt="Instalacja nawadniająca w ogrodzie - realizacja Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/nawodnienie-6.jpeg"
              alt="Instalacja nawadniająca w ogrodzie - realizacja Drzewus nr 6"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/nawodnienie-7.jpeg"
              alt="Instalacja nawadniająca w ogrodzie - realizacja Drzewus nr 7"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/nawodnienie-8.jpeg"
              alt="Instalacja nawadniająca w ogrodzie - realizacja Drzewus nr 8"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[350px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/nawodnienie-9.jpeg"
              alt="Instalacja nawadniająca w ogrodzie - realizacja Drzewus nr 9"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer3Nawodnienie;
